import { gql } from "@apollo/client"
import {
  ASSIGNED_TRIP_BOOKING_FRAG,
  ASSIGNED_TRIP_LIST_FRAG,
  ASSIGNED_TRIP_MAP_FRAG,
} from "./trip.fragments.gql"
import { INWARD_QUALITY_FRAG } from "graphql/inward/inwarding.fragments.gql"

export const SUMMARY_ASSIGNED_TRIPS = gql`
  query AssignedTripSummary(
    $date: Date!
    $departmentId: ID!
    $distributionCenterId: ID
  ) {
    summaryAssignedTrips(
      date: $date
      departmentId: $departmentId
      distributionCenterId: $distributionCenterId
    ) {
      vehicleInPremises
      vehicleInTransit
      vehicleCompleted
      maxBookings
      crateInPremises
      crateInTransit
      crateCompleted
      crateInwarded
    }
  }
`

export const FILTER_STATUS_SUMMARY = gql`
  query FilterStatusSummary(
    $date: Date!
    $departmentId: ID!
    $distributionCenterId: ID!
  ) {
    summaryFilterDetails(
      date: $date
      departmentId: $departmentId
      distributionCenterId: $distributionCenterId
    ) {
      tripStatus {
        CPCount
        ILCount
        PSCount
        DSCount
        OTCount
        NSCount
      }
    }
  }
`

export const ASSIGNED_TRIPS_LIST = gql`
  query AssignedVehiclesTripsList(
    $date: Date!
    $departmentId: ID!
    $first: Int
    $skip: Int
    $filter: AssignedTripsFilterInput
    $query: String
  ) {
    assignedVehiclesTrips(
      date: $date
      departmentId: $departmentId
      first: $first
      skip: $skip
      filter: $filter
      query: $query
    ) {
      ...AssignedTripListFrag
      bookings {
        id
        procuredQuantity
        requiredQuantity
      }
    }
  }
  ${ASSIGNED_TRIP_LIST_FRAG}
`

export const ASSIGNED_TRIPS_MAP = gql`
  query AssignedVehiclesTripsMap(
    $date: Date!
    $departmentId: ID!
    $first: Int
    $skip: Int
    $filter: AssignedTripsFilterInput
    $query: String
  ) {
    assignedVehiclesTrips(
      date: $date
      departmentId: $departmentId
      first: $first
      skip: $skip
      filter: $filter
      query: $query
    ) {
      ...AssignedTripMapFrag
    }
  }
  ${ASSIGNED_TRIP_MAP_FRAG}
`
export const ASSIGNED_TRIP_DETAILS = gql`
  query AssignedTripDetails(
    $id: Int
    $uuid: String
    $vehicleLat: Float
    $vehicleLon: Float
  ) {
    tripDetails(tripId: $id, uuid: $uuid) {
      ...AssignedTripListFrag
      unloadedBy {
        id
        name
      }
      optimisedBookings(vehicleLat: $vehicleLat, vehicleLon: $vehicleLon) {
        ...AssignedTripBookingFrag
      }
    }
  }
  ${ASSIGNED_TRIP_LIST_FRAG}
  ${ASSIGNED_TRIP_BOOKING_FRAG}
`

export const TRIP_STEP_GRAPH = gql`
  query TripStepGraph($uuid: String, $vehicleLat: Float, $vehicleLon: Float) {
    tripStepGraph(
      uuid: $uuid
      vehicleLat: $vehicleLat
      vehicleLon: $vehicleLon
    ) {
      stepId
      booking
      bookingObj {
        id
        order {
          id
          trackingCode
        }
      }
      name
      timestamp
      layer
    }
  }
`

export const TRIP_RECOMMENDATIONS = gql`
  query TripRecommendations(
    $uuid: ID!
    $vehicleLatitude: Float!
    $vehicleLongitude: Float!
  ) {
    tripRecommendation(
      uuid: $uuid
      vehicleLatitude: $vehicleLatitude
      vehicleLongitude: $vehicleLongitude
    ) {
      id
      name
      registrationCode
      variety {
        id
        name
        preferredSku {
          id
          name
        }
        commodity {
          id
          name
        }
      }
      plot {
        id
        farmer {
          id
          fullName
          number
        }
        address {
          id
          latitude
          longitude
          district
          village
        }
      }
    }
  }
`

export const FRONT_END_TRIP_DETAILS = gql`
  query frontEndTripDetails($uuid: String) {
    tripDetails(uuid: $uuid) {
      id
      status
      uuid
      vehicle {
        id
        registrationNumber
      }
      aggregator {
        id
        fullName
        number
      }
      unloadedBy {
        id
        name
      }
      sourceDepot {
        id
        name
        location {
          id
          longitude
          latitude
        }
      }
      destinationDepot {
        id
        name
        location {
          id
          latitude
          longitude
        }
      }
      orders {
        id
        trackingCode
        orderStatus
        orderStatusObj @client {
          id
          name
          intent
        }
        user {
          id
          fullName
        }
        shippingAddress {
          id
          village
          district
          latitude
          longitude
        }
        bookingsByTrip(uuid: $uuid) {
          id
          requiredQuantity
          procuredQuantity

          orderItem {
            id
            sellableItem {
              id
              name
            }
          }
        }
      }
    }
  }
`

export const TRIP_QUALITY = gql`
  query TripQuality($id: Int) {
    tripDetails(tripId: $id) {
      id
      bookings {
        id
        inwards {
          ...InwardQualityFrag
        }
      }
    }
  }
  ${INWARD_QUALITY_FRAG}
`
